import { SupportedComponents, checkContentEmpty } from './SupportedComponents';

const useProductContent = () => {
  const mapComponentName = (items: any[], additionalFields?: any) => {
    if (!items) return [];

    const mappedComponents = items.reduce((totalValue, currentValue) => {
      const componentName = currentValue?.sys?.contentType?.sys?.id;

      if (!SupportedComponents[componentName]) return totalValue;

      Object.assign(currentValue.fields, {
        component: SupportedComponents[componentName],
      });
      if (additionalFields) {
        Object.assign(currentValue.fields, additionalFields);
      }
      // Needed to not lose data at lower levels of nesting.
      if (currentValue.fields.items) {
        mapComponentName(currentValue.fields.items);
      }

      // check if component is empty and shouldn't be displayed
      if (typeof checkContentEmpty[componentName] === 'function') {
        let isEmpty = checkContentEmpty[componentName](currentValue.fields);
        if (isEmpty) {
          return totalValue;
        }
      }

      totalValue.push({
        fields: currentValue.fields,
      });

      return totalValue;
    }, []);

    if (mappedComponents.length) {
      mappedComponents[mappedComponents.length - 1].fields.isLast = true;
    }
    return mappedComponents;
  };

  /**
   * Transforms a component list to allow them to be automatically rendered.
   *
   * @param      {Array}  components        The components
   * @param      {Array}  additionalFields  The additional fields
   * @return     {Array}   The transformed components
   */
  function mapGraphQLComponentName(components, additionalFields = undefined) {
    let mappedComponents = [];
    if (!components) return mappedComponents;

    for (const component of components) {
      const typename = component?.__typename;

      Object.assign(component, {
        component: `${typename}Graphql`,
      });

      if (additionalFields) {
        Object.assign(component, additionalFields);
      }
      // Needed to not lose data at lower levels of nesting.
      if (component.items) {
        mapGraphQLComponentName(component.items);
      }

      mappedComponents.push(component);
    }

    if (mappedComponents.length) {
      mappedComponents[mappedComponents.length - 1].isLast = true;
    }

    return mappedComponents;
  }

  return {
    mapComponentName,
    mapGraphQLComponentName,
  };
};

export default useProductContent;
